/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Range_This_MonthInputs */

const cs_calendar_range_this_month = /** @type {(inputs: Calendar_Range_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento měsíc`)
};

const en_calendar_range_this_month = /** @type {(inputs: Calendar_Range_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This month`)
};

/**
* | output |
* | --- |
* | "This month" |
*
* @param {Calendar_Range_This_MonthInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_range_this_month = /** @type {((inputs?: Calendar_Range_This_MonthInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Range_This_MonthInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_range_this_month(inputs)
	return cs_calendar_range_this_month(inputs)
});